import { render, staticRenderFns } from "./InicioAdmin.vue?vue&type=template&id=6a96d90f"
import script from "./InicioAdmin.vue?vue&type=script&lang=js"
export * from "./InicioAdmin.vue?vue&type=script&lang=js"
import style0 from "./InicioAdmin.vue?vue&type=style&index=0&id=6a96d90f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard});
